import React, { useState } from 'react';
import { ProductCardProps } from '../types';
import { handleTrack } from '../../../utils/tracker';

const ProductCard: React.FC<ProductCardProps> = ({
  product,
  className = '',
}) => {
  const [isHovered, setIsHovered] = useState(false);
  const cardClasses = `w-2/5 mx-5 bg-grey-175 rounded-xl ${className} sm:w-full`;

  return (
    <div className={cardClasses}>
      <a
        href={product.link}
        data-label={product.dataLabel}
        onClick={() => {
          handleTrack({ label: 'inpage_cta_' + product.dataLabel });
        }}
      >
        <div
          className="relative overflow-hidden transition-all duration-500"
          onMouseEnter={() => setIsHovered(true)}
          onMouseLeave={() => setIsHovered(false)}
        >
          {/* Default content - visible when not hovered */}
          <div
            className={`transition-opacity duration-500 xl:w-[300px] xl:h-[300px] w-[275px] h-[275px] ${
              isHovered ? 'opacity-0' : 'opacity-100'
            }`}
          >
            <div className="flex justify-end pb-5">
              <picture>
                <source
                  className="h-full"
                  type="image/webp"
                  srcSet={product.image.webp}
                />
                <source
                  className="h-full"
                  type="image/jpeg"
                  srcSet={product.image.jpeg}
                />
                <img
                  className="h-full"
                  data-src={product.image.jpeg}
                  alt={product.image.alt}
                  width="150"
                  height="150"
                  loading="lazy"
                />
              </picture>
            </div>
            <div className="flex">
              <div className="w-3/4">
                <h5
                  className="pl-4"
                  dangerouslySetInnerHTML={{ __html: product.title }}
                />
              </div>
              <div className="w-1/4 self-end pb-4">
                <img
                  className="float-right lg:float-none"
                  src="https://assets1.cleartax-cdn.com/cleartax/images/1603291424_rightarrow_black.svg"
                  alt="blackrightarrow"
                  loading="lazy"
                />
              </div>
            </div>
          </div>

          {/* Hover content - visible when hovered */}
          <div
            className={`absolute rounded-xl inset-0 ${
              product.hoverColor
            } font-semibold transition-opacity duration-500 py-7 pl-8 pr-7 ${
              isHovered ? 'opacity-100' : 'opacity-0'
            }`}
          >
            <div
              className="text-white h-1/2 text-base"
              dangerouslySetInnerHTML={{ __html: product.subtitle }}
            />
            <div className="flex">
              <div className="w-4/5 text-white">{product.description}</div>
              <div className="w-1/5 self-end pb-4">
                <img
                  className="float-right"
                  src="https://assets1.cleartax-cdn.com/cleartax/images/1603291649_rightarrow_white.svg"
                  loading="lazy"
                  alt="whiterightarrow"
                />
              </div>
            </div>
          </div>
        </div>
      </a>
    </div>
  );
};

export default ProductCard;
